export enum ApprovalStatus {
  APPROVED = "approved",
  PENDING = "pending",
  REJECTED = "rejected",
}

export enum PRStatus {
  ACCEPT = "accept",
  REJECT = "reject",
}
export enum PaymentStatus {
  NONE = "none",
  PENDING = "pending",
  COMPLETE = "complete",
  FAILED = "failed",
}
